import { tickStep } from 'd3-array';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import InMultiSelect from '../ReportWindow/schema/InMultiSelect/InMultiSelect';
import InTable from '../ReportWindow/schema/InTable/InTable';
import './NeverCommGps.css'
import { MQTT_HOST, schemaTypes, dateFormat, dateFormatWithSec } from '../../constants/constants';
import _ from 'lodash';
import moment from 'moment';


class NeverCommGps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filteredData: [],
            locZeroData: [],
            searchStr: "",
            items: [],
            // ncGps :false,
            // locZero: false,
        }

        this.vehicleData = [];
        this.data = [];
        this.finalFilterData = {};
        this.gpsTempData = [];
        this.locZeroTemp = [];
        this.locZeroData = [];
        this.searching = false;

        this.searchVehicle = (e) => {
            let str = e.target.value.toUpperCase().trim();
            if (str.length != 0) {
                this.searching = true;
            } else {
                this.searching = false;
            }
            if (this.props.ncGps) {
                let newArray = this.state.filteredData.filter((d) => {
                    let searchValue = d.vehicleno.toUpperCase();
                    let searchDevice = d.deviceno.toUpperCase();
                    if(searchValue.indexOf(str) !== -1)return searchValue.indexOf(str) !== -1;
                    if(searchDevice.indexOf(str) !== -1)return searchDevice.indexOf(str) !== -1;
                    
                })
                this.setState({
                    items: newArray,
                })
            }
            if (this.props.locZero) {
                let newArray = this.state.locZeroData.filter((d) => {
                    let searchValue = d.vehicleno.toUpperCase();
                    let searchDevice = d.deviceno.toUpperCase();
                    if(searchValue.indexOf(str) !== -1)return searchValue.indexOf(str) !== -1;
                    if(searchDevice.indexOf(str) !== -1)return searchDevice.indexOf(str) !== -1;
                    
                })
                this.setState({
                    items: newArray,
                })
            }
        }

        this.keylistener = (e) => {
            if (e.keyCode === 27 && this.props.newbucket) this.props.closeNcgps()
        }
        this.handleCheck = (e) => {
            if(this.refs.ncgcontainer && !this.refs.ncgcontainer.contains(e.target)){ 
                this.closeSearch()
            }
        }
            
        this.closeSearch = () => {
            this.props.closeNcgps()
        }

    }
    renderHead() {
        if (this.props.locZero) {
            let head1 = [
                { key: 'vehicleno', name: 'Vehicle No', width: 110 },
                { key: 'deviceno', name: 'Device No', width: 170 },
                { key: 'model', name: 'Model', width: 100 },
                { key: 'lastcomm', name: 'Last Comm Time', width: 220 },
            ]
            return head1
        }

        if (this.props.ncGps) {
            let head2 = [
                { key: 'vehicleno', name: 'Vehicle No', width: 200 },
                { key: 'deviceno', name: 'Device No', width: 200 },
                { key: 'model', name: 'Model', width: 200 },
                // { key: 'lastcomm', name: 'Last Comm Time', width: 200 },
            ]
            return head2;

        }
    }

    getData() {
        this.data = window.vehicleMap;
        for (let idx in this.data) {
            if (this.data[idx].filters.includes('never-comm-gps')) {
                this.vehicleData.push(this.data[idx])
            }
            if (this.data[idx].filters.includes('location-zero')) {
                this.locZeroData.push(this.data[idx])
            }
        }
        if (this.vehicleData) {
            for (let idx in this.vehicleData) {
                let finalFilterData = {}
                if (this.vehicleData[idx].vehicleno) finalFilterData['vehicleno'] = this.vehicleData[idx].vehicleno;
                if (this.vehicleData[idx].devices.TRACKER.deviceno) finalFilterData['deviceno'] = this.vehicleData[idx].devices.TRACKER.deviceno;
                this.vehicleData[idx].vehicleModel.model ? finalFilterData['model'] = this.vehicleData[idx].vehicleModel.model : finalFilterData['model'] = "N/A"
                // this.vehicleData[idx].stats.gpsproctime ? finalFilterData['lastcomm'] = moment(this.vehicleData[idx].stats.gpsproctime).format('D MMM YYYY | HH:mm:ss')  : finalFilterData['lastcomm'] = "N/A"
                this.gpsTempData.push(finalFilterData)
            }
            this.setState({
                ncGps: this.props.ncGps,
                locZero: this.props.locZero,
                filteredData: this.gpsTempData
            })
        }
        if (this.locZeroData) {
            for (let idx in this.locZeroData) {
                let finalFilterData = {}
                if (this.locZeroData[idx].vehicleno) finalFilterData['vehicleno'] = this.locZeroData[idx].vehicleno;
                if (this.locZeroData[idx].devices.TRACKER.deviceno) finalFilterData['deviceno'] = this.locZeroData[idx].devices.TRACKER.deviceno;
                this.locZeroData[idx].vehicleModel.model ? finalFilterData['model'] = this.locZeroData[idx].vehicleModel.model : finalFilterData['model'] = "N/A"
                this.locZeroData[idx].stats.gpsproctime ? finalFilterData['lastcomm'] = moment(this.locZeroData[idx].stats.gpsproctime).format('D MMM YYYY | HH:mm:ss') : finalFilterData['lastcomm'] = "N/A"
                this.locZeroTemp.push(finalFilterData)
            }
            this.setState({
                locZero: this.props.locZero,
                ncGps: this.props.ncGps,
                locZeroData: this.locZeroTemp
            })
        }
    }

    componentDidMount() {
        if (this.props.newbucket) {
            this.getData()
        }
        window.addEventListener("keydown", this.keylistener);
        window.addEventListener('mousedown', this.handleCheck)
    }

    componentWillReceiveProps(props) {
        window.addEventListener("keydown", this.keylistener);
        window.addEventListener('mousedown', this.handleCheck)
    }

    render() {
        return (
            <div className={this.props.newbucket ? "ncg-container" : null} ref = "ncgcontainer">
                {/* <div className="ncgc-box"> */}
                <div className="nb-search">
                    <div className="searchClose" onClick={this.closeSearch}> x </div>
                    <input placeholder="Search" ref="searchVehicles" onChange={this.searchVehicle} ></input>
                </div>
                <div className="nb-tableContainer" >
                    <table>
                        <thead>
                            <tr>
                                {
                                    this.renderHead().map((head, index) => {
                                        return (
                                            <th key={index} style={{ width: head.width }}>{head.name} </th>
                                        )
                                    }

                                    )
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.filteredData && this.props.ncGps && !this.searching ? (this.state.filteredData.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                this.renderHead().map((head, index2) => {
                                                    return (
                                                        <td key={index2} style={{ width: head.width }}>
                                                            {item[head.key]}
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })) : this.state.locZeroData && this.props.locZero && !this.searching ? (this.state.locZeroData.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                this.renderHead().map((head, index2) => {
                                                    return (
                                                        <td key={index2} style={{ width: head.width }}>
                                                            {item[head.key]}
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })) : null
                            }
                            {
                                this.state.items && this.searching ? (this.state.items.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                this.renderHead().map((head, index2) => {
                                                    return (
                                                        <td key={index2} style={{ width: head.width }}>
                                                            {item[head.key]}
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })) : null
                            }

                        </tbody>
                    </table>
                    {
                        this.state.locZeroData.length === 0 && this.props.locZero ? (
                            <div className="noData"> NO DATA</div>
                        ) : null
                    }
                    {
                        this.state.filteredData.length === 0 && this.props.ncGps ? (
                            <div className="noData"> NO DATA</div>
                        ) : null
                    }
                </div>
                {/* </div> */}
            </div>
        )
    }

}



export default NeverCommGps;